import { __assign, __rest } from "tslib";
import { getSessionKey, getSessionID, genConditionalParams, } from "./internalUtils";
import { XSRF_HEADER } from "./constants";
import { v4 as uuidv4 } from "uuid";
var getHaloHeaders = function () {
    var _a;
    var requiredHeaders = (_a = {},
        _a[XSRF_HEADER] = getSessionKey(),
        _a["x-smar-trace-id"] = uuidv4(),
        _a);
    var sessionID = getSessionID();
    if (sessionID) {
        requiredHeaders["Smartsheet-sid"] = sessionID;
    }
    return requiredHeaders;
};
/**
 * Generates an axios configuration to be used for a Halo request.
 * A trace ID will be automatically generated for the request.
 * @param config A partial axios request configuration that will be merged
 * with the default request configuration.
 */
export var genHaloConfig = function (config) {
    var requiredHeaders = getHaloHeaders();
    var requiredParams = genConditionalParams([
        ["publishKey", "pk"],
        ["embedData", "embedData"],
        ["updateTicket", "ux"],
    ]);
    var _a = config !== null && config !== void 0 ? config : {}, inputHeaders = _a.headers, inputParams = _a.params, restOfConfig = __rest(_a, ["headers", "params"]);
    return __assign({ withCredentials: true, headers: __assign(__assign({}, requiredHeaders), inputHeaders), params: __assign(__assign({}, requiredParams), inputParams) }, restOfConfig);
};
//# sourceMappingURL=halo.js.map